import _getIterator from 'babel-runtime/core-js/get-iterator';

import NewTag from './NewTag';
import EditTag from './EditTag';

import { workTasklableIndexAPI, workTasklableDeleteAPI, workTasklableSaveAPI, workTasklableSetAPI } from '@/api/pm/tag';
import { workTaskLabelSetAPI } from '@/api/pm/projectTask';

export default {
  components: {
    NewTag: NewTag,
    EditTag: EditTag
  },
  props: {
    taskData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    placement: String
  },
  data: function data() {
    return {
      // 标签弹出框
      tagShow: false,
      // 显示tag页面
      tagContent: 0,
      // 标签筛选框
      tagSearch: '',
      // 标签数据
      tagList: [],
      // 新增、编辑标签标题
      newTagTitle: '',
      // 创建-编辑标签的输入框
      newTagInput: '',
      // 标签颜色
      bgColorProps: '',
      // 标签编辑ID
      editTagId: ''
    };
  },

  computed: {
    showTagList: function showTagList() {
      var showList = [];
      for (var index = 0; index < this.tagList.length; index++) {
        var element = this.tagList[index];
        if (element.name.indexOf(this.tagSearch) > -1) {
          showList.push(element);
        }
      }
      return showList;
    },


    // 窗口宽度
    popoverWidth: function popoverWidth() {
      // 1 新建编辑 2 管理 0 列表
      if (this.tagContent == 1) {
        return 330;
      } else if (this.tagContent == 2) {
        return 400;
      }

      return 220;
    }

    // /**
    //  * 项目ID 说明是项目
    //  */
    // workId() {
    //   return this.taskData.workId
    // }

  },
  watch: {},
  mounted: function mounted() {},

  methods: {
    /**
     * 创建新标签
     */
    createTagClick: function createTagClick() {
      this.newTagTitle = '创建新标签';
      this.newTagInput = '';
      this.tagContent = 1;
    },


    /**
     * 标签管理 -- 编辑
     */
    editTagClick: function editTagClick(val) {
      this.editTagId = val.lable_id;
      this.newTagTitle = '编辑标签';
      this.tagContent = 1;
      this.bgColorProps = val.color;
      this.newTagInput = val.name;
    },


    /**
     * 标签管理弹出框
     */
    managementTag: function managementTag() {
      this.tagContent = 2;
    },


    /**
     * 选择标签
     */
    tagSelectClick: function tagSelectClick(value, index) {
      var _this = this;

      if (this.$listeners.change) {
        value.check = !value.check;
        this.$emit('change', this.tagList.filter(function (item) {
          return item.check;
        }));
      } else {
        // 标签点击关联页面
        if (value.check) {
          workTaskLabelSetAPI({
            task_id: this.taskData.task_id,
            lable_id_del: value.lable_id,
            type: 'lable_id_del'
          }).then(function (res) {
            value.check = false;
            _this.updateDetailList(value, 'delete');
          }).catch(function () {
            value.check = true;
          });
        } else {
          var labelIds = this.tagList.filter(function (item) {
            return item.check;
          }).concat(value);

          workTaskLabelSetAPI({
            type: 'lable_id_add',
            task_id: this.taskData.task_id,
            lable_id_add: labelIds.map(function (item) {
              return item.lable_id;
            })
            // .join(',')
          }).then(function (res) {
            value.check = true;
            var labelList = [];
            _this.tagList.forEach(function (item) {
              if (item.check) {
                item.labelName = item.name;
                labelList.push(item);
              }
            });
            _this.taskData.lable_list = labelList;
          }).catch(function () {
            value.check = false;
          });
        }
      }
    },


    /**
     * 更新/删除任务详情数据
     */
    updateDetailList: function updateDetailList(value, type) {
      if (this.taskData && this.taskData.lable_list) {
        var changeIndex = -1;
        for (var index = 0; index < this.taskData.lable_list.length; index++) {
          var element = this.taskData.lable_list[index];
          if (element.lable_id == value.lable_id) {
            changeIndex = index;
            break;
          }
        }
        if (changeIndex >= 0) {
          if (type == 'delete') {
            this.taskData.lable_list.splice(changeIndex, 1);
          } else {
            this.taskData.lable_list.splice(changeIndex, 1, value);
          }
        }
      }
    },


    // 标签点击变色
    changeColor: function changeColor(val) {
      this.bgColorProps = val;
    },


    /**
     * 标签管理 -- 关闭按钮
     */
    tagClose: function tagClose() {
      this.tagShow = false;
    },


    /**
     * 创建新标签 -- 提交
     */
    tagCreateSubmit: function tagCreateSubmit(val, color) {
      var _this2 = this;

      if (this.newTagTitle == '创建新标签') {
        workTasklableSaveAPI({
          name: val,
          color: color
        }).then(function (res) {
          // 刷新标签列表
          _this2.getTagList();
          // 关闭标签页
          _this2.back();
          _this2.$message.success('创建成功');
        });
      } else {
        workTasklableSetAPI({
          name: val,
          lable_id: this.editTagId,
          color: color
        }).then(function (res) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _getIterator(_this2.tagList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.lable_id == _this2.editTagId) {
                item.name = val;
                item.color = color;
                item.labelName = item.name;
                _this2.updateDetailList(item, 'update');
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this2.tagContent = 2;
        });
      }
    },


    /**
     * 创建新标签 -- 取消
     */
    tagCancel: function tagCancel() {
      if (this.newTagTitle == '创建新标签') {
        // 关闭标签页
        this.tagClose();
        this.$message.info('已取消创建');
      } else {
        this.tagContent = 2;
      }
    },


    /**
     * 标签管理 ——— 返回上一页
     */
    back: function back() {
      if (this.tagContent == 1) {
        this.tagContent = this.newTagTitle == '创建新标签' ? 0 : 2;
      } else if (this.tagContent == 2) {
        this.tagContent = 0;
      }
    },


    /**
     * 标签管理 ——— 删除按钮
     */
    deleteBtn: function deleteBtn(val) {
      var _this3 = this;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        workTasklableDeleteAPI({
          lable_id: val.lable_id
        }).then(function (res) {
          for (var i in _this3.tagList) {
            if (_this3.tagList[i].lable_id == val.lable_id) {
              _this3.tagList.splice(i, 1);
              break;
            }
          }
          _this3.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this3.tagShow = true;
        }).catch(function () {
          // 防止窗口关闭
          _this3.tagShow = true;
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
        // 防止窗口关闭
        _this3.tagShow = true;
      });
    },


    /**
     * 获取列表数据
     */
    getTagList: function getTagList() {
      var _this4 = this;

      // 标签列表
      workTasklableIndexAPI().then(function (res) {
        var dataList = res.data.list || [];
        var selectLabels = _this4.taskData && _this4.taskData.lable_list || [];
        var selectIds = selectLabels.map(function (item) {
          return item.lable_id;
        });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _getIterator(dataList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            item.check = selectIds.includes(item.lable_id);
          }
          // 标签管理数据
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this4.tagList = dataList;
      }).catch(function () {});
    },


    /**
     * 初始化刷新
     */
    referenceFun: function referenceFun() {
      this.tagContent = 0;
      if (this.tagList && !this.tagList.length) {
        this.getTagList();
      }
    }
  }
};